module.exports = __webpack_public_path__ + "static/paymentOrchestIndex_es-5fc433161e405aeea8aca09f22ad03da.png";